<template>
    <v-content>

        <!-- for all pages -->
        <v-layout v-if="type === 'website'"
                  justify-center d-flex align-center py-5
                  style="background-color: #D7D7D7">
            <v-flex shrink>
                www.cea.or.th
            </v-flex>
        </v-layout>

        <!-- for login page -->
        <v-layout v-else-if="type === 'contact'"
                  justify-space-between px-5 py-3
                  :class="{ 'column':$vuetify.breakpoint.smAndDown, 'justify-center':$vuetify.breakpoint.smAndDown }"
                  style="background-color: #4F4F4F; height: 100%">
            <v-flex shrink d-flex align-items-center :class="{ 'mb-4':$vuetify.breakpoint.smAndDown }">

                <v-layout white--text>
                    <v-flex mr-3 d-flex justify-center align-center>
                        <img :src="require('../assets/footer-logo.png')">
                    </v-flex>
                    <v-flex d-flex align-center text-left>
                        สำนักงานส่งเสริมเศรษฐกิจสร้างสรรค์ <br>
                        (องค์การมหาชน)
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex shrink d-flex align-center>

                <v-layout white--text :class="{ 'text-right':$vuetify.breakpoint.mdAndUp }">
                    <v-flex>
                        <v-icon color="white">room</v-icon>
                        อาคารไปรษณีย์กลาง เลขที่ 1160 ถนนเจริญกรุง
                        แขวงบางรัก เขตบางรัก กรุงเทพฯ 10500 <br>
                        <v-icon color="white">call</v-icon>
                        : โทร (66) 2 105 7400
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>


    </v-content>
</template>

<script>
    export default {
        name: "Footer",
        props: ['type']
    }
</script>

<style scoped>

</style>